import React, { useState } from 'react'
import Modal from 'components/Modal'
import MoneyBackImage from 'images/content/money-back.png'
import GroupHealthForm from 'components/forms/GroupHealthForm';


export const GroupHealthBannerContent = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    document.body.style.overflow = "auto"
  };

  return (
    <div className='layout-width flex items-center'>

      <div className='w-full space-y-8 text-center lg:text-left lg:w-6/12'>
        <div className='space-y-2'>
          <div className='
            text-2xl font-extrabold
            sm:text-4xl
            md:text-5xl 
            2xl:text-7xl
          '>
            Group Health Insurance Plans
          </div>

          <div className='text-base sm:text-lg xl:text-xl'>
            With Insurance Enterprise, you can compare affordable small business group health insurance plans side-by-side. We help you find the employee group health insurance policy to save you time and money.
            Get free group health insurance quotes for your business without all the hassle.
          </div>
        </div>

        <div className='flex justify-center my-4'><img className='w-16 lg:w-32' alt='IE Logo' src={MoneyBackImage} /></div>

        <div className='lg:hidden'>
          <button className='btn btn-wide border-white border-2 btn-secondary text-base-100' onClick={() => { setOpen(true); document.body.style.overflow = "hidden" }}>GET YOUR QUOTE</button>
        </div>
      </div>


      {/* Mobile Form */}
      <Modal open={open} handleClose={handleClose}>
        <div className='flex justify-center text-primary'>
          <div className='2xl:space-y-4 max-w-md'>
            <div className='space-y-2 mb-2 2xl:mb-4'>
              <h2 className='text-xl 2xl:text-2xl font-bold'>GET AFFORDABLE HEALTH INSURANCE FOR YOUR EMPLOYEE</h2>
              <p className='text-base'>Step 1: Tell us who you are</p>
            </div>

            <GroupHealthForm openByModal={open} />

          </div>
        </div>
      </Modal>



      {/* Dekstop Form */}
      <div className='hidden lg:flex lg:justify-center mx-auto'>


        <div className='border-2 rounded bg-primary/75 p-6 2xl:p-8 2xl:space-y-4 w-11/12 max-w-lg'>
          <div className='space-y-2 mb-2 2xl:mb-4'>
            <div className='text-xl 2xl:text-2xl font-bold'>GET AFFORDABLE HEALTH INSURANCE FOR YOUR EMPLOYEE</div>
            <p className='text-base'>Step 1: Tell us who you are</p>
          </div>

          <GroupHealthForm />
          
        </div>

      </div>


    </div>
  )
}